import React, { Component } from 'react';
import styled from 'styled-components';
import { Transition } from 'transition-group';

import ModalSwitcher from '../ModalSwitcher/index';
import { Screen } from 'components/Common';
import { Page } from 'components/v2/Common';
import { BackLink } from '../Navigation/BackLink';
import { AutomationText } from '../Automation';
import {ShareAppButton, ShareAppButtonContainer} from '../ShareApp/index';

import {
  iOSNavbarHeight,
  androidNavbarBottomRowHeight,
  androidNavbarTopRowHeight,
  androidNavbarHeight,
  iOSNavbarHeightNumber
} from 'themes';
import { isiOS } from 'config';
import { AppType } from '../../../constants';

const BackDiv = styled.div`
  position: absolute;
  padding: 11px 16px;
`;

const Title = styled.div`
  position: absolute;
  left: 50%;
  overflow: hidden;
  transform: translate(-50%, -50%);
  ${isiOS
    ? `
    top: ${iOSNavbarHeightNumber / 2}px;
  `
    :`
    top: ${androidNavbarBottomRowHeight / 2}px;
  `}
`;

interface LayoutProps {
  tabs?: number;
  pageElement?: React.ReactChild;
  direction?: string;
  name?: string;
  scrollKey?: string;
  center?: string;
  app?: any
}

export default class Layout extends Component<LayoutProps> {
  state = {
    scrolling: false,
    top: 0
  };

  onScroll = ({ scrolling = false, top = 0 }) => {
    if (isiOS && this.state.scrolling === scrolling) {
      return;
    }
    if (top > androidNavbarTopRowHeight) {
      top = androidNavbarTopRowHeight;
    }
    if (this.state.scrolling === scrolling && this.state.top === top) {
      return;
    }
    this.setState({
      scrolling,
      top
    });
  };

  render() {
    const {
      tabs,
      pageElement,
      direction,
      name,
      scrollKey,
      center,
      app
    } = this.props;
    const { top } = this.state;

    let navbarHeight = iOSNavbarHeight;
    let savedNavigator = (window.navigator as any);
    if (!isiOS) {
      navbarHeight = tabs
        ? androidNavbarHeight({ top })
        : `${androidNavbarTopRowHeight}px`;
    }

    let NavigationEl = (
      <div>
        <BackDiv>
          <BackLink />
        </BackDiv>
        { center &&
          <Title className="permissions-title-v2" aria-label="permissions-title" id="permissions-title">{center}</Title>
        }
        { isiOS && app && !app.isPrivate && app.type.toLocaleLowerCase() !== AppType.TILE && savedNavigator.share &&
          <ShareAppButtonContainer>
            <ShareAppButton id={"share-app-button"} app={app} paddingTop={true}/>
            <AutomationText/>
          </ShareAppButtonContainer>}
      </div>
    );

    let PageEl = (
      <Page
        onScroll={this.onScroll}
        navbarHeight={navbarHeight}
        scrollKey={scrollKey}
      >
        {pageElement}
      </Page>
    );

    if (isiOS && direction !== 'slide-left' && direction !== 'slide-right') {
      NavigationEl = (
        <Transition key={`${name}-nav`} className={`nav-${direction}`}>
          {NavigationEl}
        </Transition>
      );
      PageEl = (
        <Transition key={`${name}-page`} className={direction}>
          {PageEl}
        </Transition>
      );
    }

    return (
      <Screen className="screen v2-top-bar">
        <ModalSwitcher />
        {NavigationEl}
        {PageEl}
      </Screen>
    );
  }
}
